// Projects content reproduced from Mashmari's site (titles, descriptions, document
// names). All media (images, videos, thumbnails, documents) is hosted locally under
// /home, /videos, /video-thumbs and /docs — see /app/memory/ASSET_MANIFEST.md for
// each asset's original source URL and its new local location.

export const projectCards = [
  {
    id: 'niit-mobile-education-bus',
    icon: 'bus',
    title: 'NIIT Foundation Mobile Education Bus',
    body: 'Taking structured, technology-enabled learning directly to underserved communities through mobile classrooms equipped with ICT infrastructure and trained facilitators.',
    to: null,
    unavailable: 'The reference page shows this card without a detail view — no overview, documents or media are published for it yet.',
  },
  {
    id: 'bbps-remote-education',
    icon: 'school',
    title: 'BBPS Management Schools – Remote Education Initiative',
    body: 'Extending high-quality, structured instruction from urban centres to management students across geographies through technology-enabled delivery.',
    to: null,
    unavailable: 'The reference page shows this card without a detail view — no overview, documents or media are published for it yet.',
  },
  {
    id: 'wcdd-haryana',
    icon: 'laptop',
    title: 'WCDD Haryana Digital Anganwadi Pilot',
    body: 'A 67-centre pilot operationalizing the NCF-FS Aadharshila framework within Anganwadi Centres using BSNL FTTH connectivity and automated video lesson playlists.',
    to: '/projects/wcdd-haryana',
  },
  {
    id: 'satnavari-digital-anganwadi',
    icon: 'book',
    title: 'Satnavari, Maharashtra – Digital Anganwadi Initiative',
    body: "Extending quality early childhood education to India's first Smart Intelligent Village through frugal digital infrastructure and autonomous classroom technology.",
    to: '/projects/satnavari-digital-anganwadi',
  },
  {
    id: 'satnavari-gyaan-megh',
    icon: 'graduation',
    title: 'Satnavari, Maharashtra – CES Gyaan Megh Remedial Classroom',
    body: 'Addressing foundational learning gaps among village children through AI-assisted assessment and expert-led instruction with personalized remedial pathways.',
    to: null,
    unavailable: 'The reference page shows this card without a detail view — no overview, documents or media are published for it yet.',
  },
  {
    id: 'project-videos',
    icon: 'video',
    title: 'Project Videos',
    body: 'Field footage, worker testimonials, classroom sessions, and impact documentation from all Mashmari project implementations.',
    to: '/projects/videos',
  },
];

export const wcddProject = {
  icon: 'laptop',
  title: 'WCDD Haryana Digital Anganwadi Pilot',
  overview:
    "The Haryana WCD Department's 67-centre Digital Anganwadi Pilot aimed to operationalize the NCF-FS Aadharshila framework within Anganwadi Centres—a challenge long considered impractical at scale. By combining BSNL FTTH connectivity, automated video lesson playlists, and simplified classroom technology, the initiative enabled the 48-week curriculum into daily, play-based, vernacular learning activities. Anganwadi Workers were empowered to deliver high-quality ECCE independent of prior pedagogical depth. Real-time monitoring and playback logs made classroom activity evidenceable for governance. The pilot delivered visible gains in attendance, engagement, worker confidence, and parental trust, establishing a nationally replicable digital ECCE model.",
  artefactsIntro:
    'Documentation and evidence materials demonstrating project implementation, training completion, and impact assessment. Click on any folder to view its files.',
  artefacts: [
    {
      id: 'play-logs',
      tag: 'Anganwadi',
      title: 'Anganwadi Wise Play Logs Analysis',
      meta: 'Activity monitoring dashboard',
      action: 'view',
      viewUrl: 'https://monitoring.mashmari.in/activity/',
      files: [],
    },
    {
      id: 'delivery-completion',
      tag: 'Anganwadi',
      title: 'Anganwadi wise signed delivery completion list',
      meta: '1 file available',
      action: 'download',
      files: [{
        name: 'Anganwadi-wise-signed-delivery-completion-list.pdf',
        url: '/docs/Anganwadi-wise-signed-delivery-completion-list.pdf',
      }],
    },
    {
      id: 'installation-completion',
      tag: 'Anganwadi',
      title: 'Anganwadi wise signed installation completion list',
      meta: '1 file available',
      action: 'download',
      files: [{
        name: 'Anganwadi-wise-signed-installation-completion-list.pdf',
        url: '/docs/Anganwadi-wise-signed-installation-completion-list.pdf',
      }],
    },
    {
      id: 'closure-mom',
      tag: 'Project',
      title: 'Project Closure Worker Feedback Meeting Minutes',
      meta: '1 file available',
      action: 'download',
      files: [{
        name: 'MoM_Digital_AWC_Ambala_16Sep2025_EN_Hi_Ext-2.docx',
        url: '/docs/MoM_Digital_AWC_Ambala_16Sep2025_EN_Hi_Ext-2.docx',
      }],
    },
    {
      id: 'worker-feedback-survey',
      tag: 'Worker',
      title: 'Worker feedback report-survey',
      meta: '1 file available',
      action: 'download',
      files: [{
        name: 'Worker-feedback-report-survey-response.pdf',
        url: '/docs/Worker-feedback-report-survey-response.pdf',
      }],
      note: undefined,
    },
    {
      id: 'worker-feedback-training',
      tag: 'Worker',
      title: 'Worker feedback report-training',
      meta: '1 file available',
      action: 'download',
      files: [{
        name: 'Worker-feedback-report-training.pdf',
        url: '/docs/Worker-feedback-report-training.pdf',
      }],
    },
    {
      id: 'worker-training-attendance',
      tag: 'Worker',
      title: 'Worker Training Attendence Sheet',
      meta: '1 file available',
      action: 'download',
      files: [{
        name: 'Worker-Training-Attendence-Sheet.pdf',
        url: '/docs/Worker-Training-Attendence-Sheet.pdf',
      }],
    },
    {
      id: 'wcdd-videos',
      tag: 'Artifacts',
      title: 'Project Videos',
      meta: '11 videos available',
      action: 'videos',
    },
  ],
  highlights: [
    { value: '67', label: 'Centres Covered' },
    { value: '48', label: 'Week Curriculum' },
    { value: '100%', label: 'FTTH Connected' },
    { value: 'NCF-FS', label: 'Framework Aligned' },
  ],
};

export const satnavariProject = {
  icon: 'book',
  title: 'Satnavari, Maharashtra – Digital Anganwadi Initiative',
  overview:
    "Extending quality early childhood education to India's first Smart Intelligent Village through frugal digital infrastructure and autonomous classroom technology.",
  artefactsIntro: 'Documentation and evidence materials from the Satnavari Digital Anganwadi Initiative. Click on any item to view.',
  artefacts: [
    { id: 'satnavari-videos', tag: 'Artifacts', title: 'Project Videos', meta: '11 videos available', action: 'videos' },
  ],
};

export const projectVideos = [
  {
    number: 'Video 01', badge: 'Exercise', tag: 'Physical Activity',
    poster: '/video-thumbs/video-01.jpg',
    title: 'Teaching Exercising with Video Lessons',
    desc: 'Children at the Satnavari Anganwadi learning physical exercises through structured video-led activity sessions as part of the daily curriculum.',
    src: '/videos/video-01.mp4',
  },
  {
    number: 'Video 02', badge: 'Field Visit', tag: 'Field Documentation',
    poster: '/video-thumbs/video-02.jpg',
    title: 'Satnavari Maharashtra Anganwadi',
    desc: "Field documentation of the Satnavari Anganwadi centre — digital infrastructure, classroom setup and day-to-day operations in India's first Smart Intelligent Village.",
    src: '/videos/video-02.mp4',
  },
  {
    number: 'Video 03', badge: 'Circle Time', tag: 'Circle Time',
    poster: '/video-thumbs/video-03.jpg',
    title: 'Satnavari Maharashtra Circle Time',
    desc: 'A Circle Time session at the Satnavari Anganwadi with children engaging in group activities, songs, and interactive video-led routines.',
    src: '/videos/video-03.mp4',
  },
  {
    number: 'Video 04', badge: 'Circle Time', tag: 'Circle Time',
    poster: '/video-thumbs/video-04.jpg',
    title: 'Ambala Anganwadi Workers with Mashmari Circle Time Video',
    desc: 'Anganwadi Workers in Ambala conducting a structured Circle Time session using the Mashmari video playlist system with children.',
    src: '/videos/video-04.mp4',
  },
  {
    number: 'Video 05', badge: 'Content', tag: 'Marathi Language',
    poster: '/video-thumbs/video-05.jpg',
    title: 'Marathi Content',
    desc: 'Locally produced Marathi-language educational content designed for the Satnavari Anganwadi, ensuring culturally relevant mother-tongue learning.',
    src: '/videos/video-05.mp4',
  },
  {
    number: 'Video 06', badge: 'Impact', tag: 'Early Impact',
    poster: '/video-thumbs/video-06.jpg',
    title: 'Ambala AWC Result after some days: Welcoming with Good Morning',
    desc: 'After just a few days of the digital programme, children at the Ambala AWC are confidently greeting visitors with a "Good Morning" — a visible early outcome of the intervention.',
    src: '/videos/video-06.mp4',
  },
  {
    number: 'Video 07', badge: 'Feedback', tag: 'Worker Feedback',
    poster: '/video-thumbs/video-07.jpg',
    title: 'Ambala Panjokhra Digital AWC – Worker Feedback',
    desc: 'A worker from the Panjokhra Anganwadi in Ambala shares her firsthand experience operating the digital classroom and the changes she observed in children.',
    src: '/videos/video-07.mp4',
  },
  {
    number: 'Video 08', badge: 'Content Studio', tag: 'Content Creation',
    poster: '/video-thumbs/video-08.jpg',
    title: 'Worker Recording Local Language Video Lesson at Content Studio',
    desc: 'An Anganwadi Worker records a vernacular-language video lesson at the content studio, contributing to the locally relevant playlist library used across centres.',
    src: '/videos/video-08.mp4',
  },
  {
    number: 'Video 09', badge: 'Impact', tag: 'Community Impact',
    poster: '/video-thumbs/video-09.jpg',
    title: 'Ambala Digital AWC Impact – Workers, Children and Parents Learn to Say Bye',
    desc: 'A heartwarming moment showing how the digital programme built social confidence — workers, children, and parents all joining in to wave goodbye together.',
    src: '/videos/video-09.mp4',
  },
  {
    number: 'Video 10', badge: 'Testimonial', tag: 'Worker Testimonial',
    poster: '/video-thumbs/video-10.jpg',
    title: 'Kanwla Anganwadi Ambala – Worker Appreciates Progress After BSNL Intervention',
    desc: 'The Anganwadi Worker at Kanwla, Ambala reflects on the remarkable progress both the children and the centre have made since the BSNL digital intervention.',
    src: '/videos/video-10.mp4',
  },
  {
    number: 'Video 11', badge: 'Transformation', tag: 'Transformation',
    poster: '/video-thumbs/video-11.jpg',
    title: 'Ambala Digital AWC – Children Who Came Crying Now Go Back Crying',
    desc: "A powerful testimonial from an Ambala worker — children who once cried coming in now cry when it's time to go home, a defining measure of engagement and belonging.",
    src: '/videos/video-11.mp4',
  },
];

// Homepage capability carousel — Mashmari's flagship solution infographics,
// hosted locally under /home.
export const homeSlides = [
  {
    kind: 'promo',
    image: 'imc-2026-promo',
    label: 'Meet Mashmari at IMC 2026',
    alt: 'Meet Mashmari at India Mobile Congress 2026, 7–10 October 2026, Yashobhoomi, New Delhi',
  },
  {
    image: '/home/safe-monitored-learning.png',
    label: 'Safe and Monitored Learning Management',
    alt: 'Infographic: Safe and Monitored Learning Management — NetRakshak policy orchestration connecting BSNL FTTH, device registration, policy control, compromise detection and personalised adaptive learning with Megh LMS and Doot',
  },
  {
    image: '/home/digital-tlm-factory.webp',
    label: 'Digital TLM Factory',
    alt: 'Infographic: Digital TLM Factory — seven-step cycle from curriculum ingestion and competency intelligence to AI-assisted TLM generation, review, publishing, classroom implementation and continuous improvement',
  },
  {
    image: '/home/composite-skill-labs.webp',
    label: 'Composite Skill Labs',
    alt: 'Infographic: Composite Skill Lab bringing together Robotics, AI/ML, Coding, Python, Sensors, AR/VR, Astronomy and Computational Science under one Explore, Create, Solve lab',
  },
  {
    image: '/home/megh-lms-ai-enabled.webp',
    label: 'Megh LMS — AI-Enabled Teaching, Learning & Assessment',
    alt: 'Infographic: AI-Enabled LMS covering learner management, digital content, teaching and learning, assessment and analytics, AI-powered learning and EIR knowledge resources',
  },
  {
    image: '/home/village-school-transformation.webp',
    label: 'Village School Transformation',
    alt: 'Infographic: Village School Transformation — affordable, connected, future-ready learning with connected schools, digital classrooms, teacher enablement, learner assessment and sustainable impact',
  },
  {
    image: '/home/digital-anganwadi.webp',
    label: 'Mashmari Digital Anganwadi',
    alt: 'Infographic: Mashmari Digital Anganwadi — Saksham Anganwadi infrastructure with Anganwadi Bhavan, early learning spaces, toilets, solar power, CCTV and kitchen, alongside Digital Anganwadi and Smart ECCE outcomes of joyful children, empowered workers, stronger communities, confident supervisors and better outcomes',
  },
  {
    image: '/home/personalised-adaptive-learning.webp',
    label: 'Personalised Adaptive Learning',
    alt: 'Infographic: Personalised Adaptive Learning powered by AI — AI assessment, learner profile and competency map, AI recommended personalised learning path and improved learning outcomes with continuous progress tracking',
  },
  {
    image: '/home/secure-mdm.webp',
    label: 'Secure MDM — Managed & Cyber-Secure Student Tablets',
    alt: 'Infographic: Secure MDM for managed and cyber-secure student tablets — centralised device management, controlled apps and safe browsing, purposeful learning environment, network security monitoring and real-time compliance reporting',
  },
  {
    image: '/home/netrakshak-connected-intelligence.webp',
    label: 'NetRakshak Connected Intelligence Ecosystem',
    alt: 'Infographic: NetRakshak — from connected device to intelligent, managed and safer network via NetRakshak Agent, NetRakshak Portal and MDM, delivering outcomes for telecom service providers, ISPs and enterprises, device OEMs and education or government',
  },
];
